import axios from '@/axiosInterceptor';

const state = () => ({
  errors: {
    phone: false,
    email: false,
  },
  show: null,
});

// getters
const getters = {};

// actions

const actions = {
  async createContact({ commit }, payload) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY + '/api/v1/onboarding_packets/' + payload.id,
        payload.body
      );
      // await dispatch(
      //   "onboardingPacket/getOnboardingPacketById",
      //   { id: payload.id },
      //   { root: true }
      // );
      commit('setShow', res.data.identity);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        if (status === 422) {
          if (e.response.data['phones.value']) commit('setPhoneError', true);
          if (e.response.data['email_addresses.value'])
            commit('setEmailError', true);
        }
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async deleteContact({ dispatch }, { contact_id, contact_is_type, payload }) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY + '/api/v1/contacts/' + contact_id,
        payload
      );
      if (res) {
        let res2 = await axios.delete(
          process.env.API_IDENTITY + '/api/v1/contacts/' + contact_id
        );
        if ([204].includes(res2.status)) {
          await dispatch('contacts/removeSavedContactByType', contact_is_type, {
            root: true,
          });
          return res2;
        }
      }

      // commit("setShow", res.data.identity);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

//mutations
const mutations = {
  setPhoneError(state, el) {
    state.errors.phone = el;
  },
  setEmailError(state, el) {
    state.errors.email = el;
  },
  resetErrors(state) {
    state.errors.email = false;
    state.errors.phone = false;
  },
  setShow(state, el) {
    state.show = el;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
